module.exports = __webpack_public_path__ + "static/media/10.f2317fd1.jpg";